// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uk-modal.uk-modal-vcenter.uk-open {
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.uk-modal.modal-choose-wide .uk-modal-dialog {
  width: 760px;
  max-width: calc(100vw - 32px);
}
.uk-modal.modal-choose-wide .uk-modal-body {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}
.modal-choose-with-details .modal-choose-message {
  margin: 0 0 16px;
  color: #555;
  line-height: 1.5;
}
.modal-choose-with-details .modal-choose-details {
  display: grid;
  gap: 10px;
}
.modal-choose-with-details .modal-choose-detail {
  padding: 12px 14px;
  border: 1px solid #dfe3e8;
  border-radius: 4px;
  background: #fafbfc;
}
.modal-choose-with-details .modal-choose-detail-highlight {
  border-color: #8eb4d6;
  border-left: 4px solid #003768;
  background: #f2f7fb;
}
.modal-choose-with-details .modal-choose-detail-label {
  display: block;
  margin-bottom: 4px;
  color: #003768;
  font-size: 14px;
}
.modal-choose-with-details .modal-choose-detail-text {
  margin: 0;
  color: #222;
  line-height: 1.55;
  overflow-wrap: anywhere;
}
.modal-choose-with-details .modal-choose-footer-message {
  margin: 18px 0 0;
  font-weight: 600;
  color: #222;
}
@media (max-width: 640px) {
  .uk-modal.modal-choose-wide .uk-modal-dialog {
    max-width: calc(100vw - 16px);
  }
  .uk-modal.modal-choose-wide .uk-modal-header,
  .uk-modal.modal-choose-wide .uk-modal-body,
  .uk-modal.modal-choose-wide .uk-modal-footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.uk-modal.reactivation-choice-modal [data-modal-choice].uk-button-default {
  background-color: #fff;
  border-color: #e5e5e5;
  color: #222;
}
.uk-modal.reactivation-choice-modal [data-modal-choice].uk-button-default:hover {
  background-color: #003768;
  border-color: #003768;
  color: #fff;
}
.uk-modal.reactivation-choice-modal [data-modal-choice].uk-button-default:focus:not(:hover) {
  background-color: #fff;
  border-color: #003768;
  color: #222;
}
.uk-modal.reactivation-choice-modal [data-modal-choice].uk-button-default:focus-visible {
  outline: 2px solid #003768;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal.less"],"names":[],"mappings":"AAGA;EACI,wBAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAKA;EAEQ,YAAA;EACA,6BAAA;AAJR;AACA;EAOQ,+BAAA;EACA,gBAAA;AALR;AASA;EAEQ,gBAAA;EACA,WAAA;EACA,gBAAA;AARR;AAIA;EAQQ,aAAA;EACA,SAAA;AATR;AAAA;EAaQ,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAVR;AANA;EAoBQ,qBAAA;EACA,8BAAA;EACA,mBAAA;AAXR;AAXA;EA0BQ,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAZR;AAjBA;EAiCQ,SAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AAbR;AAvBA;EAwCQ,gBAAA;EACA,gBAAA;EACA,WAAA;AAdR;AAkBA;EACI;IAEQ,6BAAA;EAjBV;EAeE;;;IAQQ,kBAAA;IACA,mBAAA;EAlBV;AACF;AAwBA;EACI,sBAAA;EACA,qBAAA;EACA,WAAA;AAtBJ;AAwBI;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;AAtBR;AAyBI;EACI,sBAAA;EACA,qBAAA;EACA,WAAA;AAvBR;AA0BI;EACI,0BAAA;EACA,mBAAA;AAxBR","sourcesContent":["// Centraliza verticalmente um modal UIkit. A classe e aplicada via JS no\n// Modal.confirm. O seletor restringe ao estado \"aberto\" (.uk-open) para\n// nao interferir no display: none quando o modal e fechado.\n.uk-modal.uk-modal-vcenter.uk-open {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n}\n\n.uk-modal.modal-choose-wide {\n    .uk-modal-dialog {\n        width: 760px;\n        max-width: calc(100vw - 32px);\n    }\n\n    .uk-modal-body {\n        max-height: calc(100vh - 220px);\n        overflow-y: auto;\n    }\n}\n\n.modal-choose-with-details {\n    .modal-choose-message {\n        margin: 0 0 16px;\n        color: #555;\n        line-height: 1.5;\n    }\n\n    .modal-choose-details {\n        display: grid;\n        gap: 10px;\n    }\n\n    .modal-choose-detail {\n        padding: 12px 14px;\n        border: 1px solid #dfe3e8;\n        border-radius: 4px;\n        background: #fafbfc;\n    }\n\n    .modal-choose-detail-highlight {\n        border-color: #8eb4d6;\n        border-left: 4px solid #003768;\n        background: #f2f7fb;\n    }\n\n    .modal-choose-detail-label {\n        display: block;\n        margin-bottom: 4px;\n        color: #003768;\n        font-size: 14px;\n    }\n\n    .modal-choose-detail-text {\n        margin: 0;\n        color: #222;\n        line-height: 1.55;\n        overflow-wrap: anywhere;\n    }\n\n    .modal-choose-footer-message {\n        margin: 18px 0 0;\n        font-weight: 600;\n        color: #222;\n    }\n}\n\n@media (max-width: 640px) {\n    .uk-modal.modal-choose-wide {\n        .uk-modal-dialog {\n            max-width: calc(100vw - 16px);\n        }\n\n        .uk-modal-header,\n        .uk-modal-body,\n        .uk-modal-footer {\n            padding-left: 20px;\n            padding-right: 20px;\n        }\n    }\n}\n\n// As escolhas de reativacao iniciam neutras. A classe e aplicada somente\n// pelo fluxo de Cliente/Ficha inativos, sem alterar os demais Modal.choose.\n.uk-modal.reactivation-choice-modal [data-modal-choice].uk-button-default {\n    background-color: #fff;\n    border-color: #e5e5e5;\n    color: #222;\n\n    &:hover {\n        background-color: #003768;\n        border-color: #003768;\n        color: #fff;\n    }\n\n    &:focus:not(:hover) {\n        background-color: #fff;\n        border-color: #003768;\n        color: #222;\n    }\n\n    &:focus-visible {\n        outline: 2px solid #003768;\n        outline-offset: 2px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
